import { gql } from '@apollo/client'

import { BookingAllocatedDriverFragment, BookingDriverFragment } from 'graphql/fragments'

export const ALLOCATE_DRIVERS = gql`
    mutation createBookingDrivers($input: [CreateAndUpdateBookingDriverDtoInput!]!) {
        createBookingDrivers(input: $input) {
            id
            ...BookingAllocatedDriver

            booking {
                id
                takenBy
                takenOn
                status
                statusLabel
                isBiddingEnabled
            }
        }
        ${BookingAllocatedDriverFragment}
    }
`

export const ALLOCATE_DRIVER_MUTATION = gql`
    mutation CreateBookingDriver($input: CreateAndUpdateBookingDriverDtoInput!) {
        createBookingDriver(input: $input) {
            id
            ...BookingAllocatedDriver
            booking {
                id
                takenBy
                takenOn
                status
                statusLabel
                isBiddingEnabled
            }
        },
        ${BookingAllocatedDriverFragment}

    }
`

export const UPDATE_DRIVER_MUTATION = gql`
    mutation UpdateAllocatedDriver($input: CreateAndUpdateBookingDriverDtoInput!) {
        updateAllocatedDriver(input: $input) {
            id
            ...BookingAllocatedDriver
        },
        ${BookingAllocatedDriverFragment}
    }
`

export const REPLACE_ALLOCATED_DRIVER_MUTATION = gql`
    mutation ReplaceAllocatedDriver($input: CreateAndUpdateBookingDriverDtoInput!) {
        replaceAllocatedDriver(input: $input) {
            id
            ...BookingAllocatedDriver
        },
        ${BookingAllocatedDriverFragment}
    }
`

export const REPLACE_DRIVER_MUTATION = gql`
  mutation ReplaceBookingDriver($input: ReplaceBookingDriverDtoInput!) {
    replaceBookingDriver(input: $input) {
      ...BookingDriverFragment
    }
  }
  ${BookingDriverFragment}
`

export const DEALLOCATE_DRIVER_MUTATION = gql`
    mutation DeleteBookingDriver($bookingDriverId: Long!) {
        deleteBookingDriver(bookingDriverId: $bookingDriverId) {
            id
            ...BookingAllocatedDriver
        }
        ${BookingAllocatedDriverFragment}
    }
`

export const CREATE_BID_ALLOCATION = gql`
  mutation CreateBidAllocation($input: CreateBidAllocationDtoInput!) {
    createBidAllocation(input: $input) {
      ...BookingDriverFragment
    }
  }
  ${BookingDriverFragment}
`
